import { Component, ViewEncapsulation, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { MatIconButton } from '@angular/material/button';

interface IconMethodCellModel extends ICellRendererParams<unknown, unknown> {
	icon: string;
	onClick<T>(param: T): null;
}

@Component({
	selector: 'copo-icon-method-cell',
	templateUrl: './icon-method-cell.component.html',
	styleUrl: './icon-method-cell.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, MatIconModule, MatIconButton]
})
export class IconMethodCellComponent implements ICellRendererAngularComp {
	@HostBinding('class.passthrough') readonly passthrough = true;

	icon?: string;
	params?: IconMethodCellModel;

	constructor(readonly changeDetectorRef: ChangeDetectorRef) {}

	agInit(params: IconMethodCellModel): void {
		this.params = params;
		this.changeDetectorRef.markForCheck();
		this.icon = params.icon;
	}

	refresh(params: IconMethodCellModel): boolean {
		this.params = params;
		this.changeDetectorRef.markForCheck();
		this.icon = params.icon;
		return true;
	}

	onClick<T>() {
		if (this.params && typeof this.params.onClick === 'function') {
			this.params.onClick<T>(<T> this.params.node.data);
		}
	}
}
